module.exports = __webpack_public_path__ + "img/XVC-alt.9bb80aca.svg";